import styled from 'styled-components';
import { MdChevronRight } from 'react-icons/md';

const StyledLink = styled.div`
  font: Inter;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: ${(props) => props.color || 'black'};
  text-decoration: none;
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 64px;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 32px;
  box-shadow: 0px 1px 0px 0px #f0f0f0;
  z-index: 9;
`;
const StyledChevronRightIcon = styled(MdChevronRight)`
  margin: 0 20px;
`;
const Styled = {
  StyledLink,
  Container,
  StyledChevronRightIcon,
};

export default Styled;
